import { createContext } from 'react';

export interface DetailsPanelDisplayState {
  isFloating: boolean;
  hasBackdrop: boolean;
}

export const DetailsPanelDisplayContext = createContext<DetailsPanelDisplayState>({
  isFloating: false,
  hasBackdrop: false,
});
